import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaShoppingCart, FaUser } from "react-icons/fa";
import "./Cart.css";
import CommonFooter from "../../components/footer/CommonFooter";
// import HomeHeader from "../../components/header/HomeHeader";
import CommonButton from "../../components/button/CommonButton";
import CartProduct from "./component/cartProduct";
import CartQtyUpdateModal from "./component/cartQtyUpdateModal";
import { appApiHandler } from "../../api/appApiHandler";
import { setCartCount } from "../../store/slices/countState";
import FullScreenLoader from "../../components/loader/fullScreenLoader/FullscreenLoader";
import EmptyState from "../../components/EmptyState";
import { showErrorToast } from "../../utils/toast";
import { getErrorMessage } from "../../constants/globalFunction";
import { string } from "../../constants/string";
import Breadcrumb from "../../components/breadcrumb";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.userState);
  const { isLoggedIn } = useSelector((state) => state.authState);

  const [products, setProducts] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showQtyModal, setShowQtyModal] = useState(false);

  const getCartProducts = async () => {
    const reqData = {
      user_id: userData?._id,
    };
    const response = await appApiHandler.getCart(reqData);
    if (response?.status === 200 && response?.data) {
      dispatch(setCartCount(response?.data?.products?.length));
      setProducts(response?.data?.products);
    }

    setLoading(false);
    setSelectedItem(null);
  };

  useEffect(() => {
    if (isLoggedIn && userData?._id) {
      setLoading(true);
      getCartProducts();
    }
  }, [isLoggedIn, userData?._id]);

  const handleIncreaseQty = async (item) => {
    setSelectedItem(item);
    const reqData = {
      user_id: userData?._id,
      cart_id: item?.cart_id,
      product_id: item?._id,
      size_id: item?.size_id,
      qty: item?.qty + 1,
      color_id: item?.color_id,
    };
    const response = await appApiHandler.addToCart(reqData);
    if (response?.status === 200) {
      getCartProducts();
    } else if (response?.message) {
      setSelectedItem(null);
      showErrorToast(getErrorMessage(response?.message));
    } else {
      setSelectedItem(null);
      showErrorToast(string.error.failed_due_to_internal_error);
    }
  };

  const handleUpdateQty = async (qty) => {
    setShowQtyModal(false);
    const reqData = {
      user_id: userData?._id,
      cart_id: selectedItem?.cart_id,
      product_id: selectedItem?._id,
      size_id: selectedItem?.size_id,
      qty: qty,
      color_id: selectedItem?.color_id,
    };

    const response = await appApiHandler.addToCart(reqData);
    if (response?.status === 200) {
      getCartProducts();
    } else if (response?.message) {
      setSelectedItem(null);
      showErrorToast(getErrorMessage(response?.message));
    } else {
      setSelectedItem(null);
      showErrorToast(string.error.failed_due_to_internal_error);
    }
  };

  const handleDecreaseQty = async (item, deleteItem = false) => {
    setSelectedItem(item);
    const reqData = {
      user_id: userData?._id,
      product_id: item?._id,
      size_id: item?.size_id,
      qty: deleteItem || item?.qty <= 1 ? 0 : item?.qty - 1,
      color_id: item?.color_id,
    };
    const response = await appApiHandler.removeFromCart(reqData);
    if (response?.status === 200) {
      getCartProducts();
    } else if (response?.message) {
      setSelectedItem(null);
      showErrorToast(getErrorMessage(response?.message));
    } else {
      setSelectedItem(null);
      showErrorToast(string.error.failed_due_to_internal_error);
    }
  };

  const onPressCheckout = () => {
    const hasUnavailable = products.some((p) => p?.is_update);
    if (hasUnavailable) {
      showErrorToast("Please remove unavailable items");
      return;
    }
    navigate("/address");
  };

  const onPressQty = (item) => {
    setSelectedItem(item);
    setShowQtyModal(true);
  };

  const onCancelQty = () => {
    setSelectedItem(null);
    setShowQtyModal(false);
  };

  const renderProducts = useCallback(
    (item) => {
      return (
        <CartProduct
          key={item?._id}
          item={item}
          onIncreaseQty={handleIncreaseQty}
          onDecreaseQty={handleDecreaseQty}
          selectedItem={selectedItem}
          onPressQty={onPressQty}
        />
      );
    },
    [products, selectedItem]
  );

  return (
    <div className="cartPage">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "My Cart",
            isActive: true,
          },
        ]}
      />
      {!isLoggedIn ? (
        <EmptyState
          icon={FaUser}
          title="Sign In to Continue"
          description="Please login with your account to view your cart and continue shopping!"
          buttonText="Login"
          onButtonClick={() => navigate("/login")}
          iconSize={48}
        />
      ) : loading ? (
        <div className="cartPage__loading">
          <FullScreenLoader text="Loading cart..." />
        </div>
      ) : products?.length > 0 ? (
        <main className="cartPage__main">
          <section className="cartPage__content">
            <div className="cartPage__list">
              {products?.map((item) => renderProducts(item))}
            </div>
          </section>
          <CommonButton
            title="Checkout"
            onPress={onPressCheckout}
            disabled={loading}
            customClassName="cartPage__checkoutBtn"
          />
        </main>
      ) : (
        <EmptyState
          icon={FaShoppingCart}
          title="Your cart is empty"
          description="Start adding products to your cart by browsing our collection."
          buttonText="Continue Shopping"
          onButtonClick={() => navigate("/")}
          iconSize={60}
        />
      )}
      {/*       
       <main className="cartPage__main">
       {loading ? (
          <div className="cartPage__loading">
            <FullScreenLoader text="Loading cart..." />
          </div>
        ) : products?.length > 0 ? (
          <>
            <section className="cartPage__content">
              <div className="cartPage__list">
                {products?.map((item) => renderProducts(item))}
              </div>
            </section>

            <CommonButton
              title="Checkout"
              onPress={onPressCheckout}
              disabled={loading}
              customClassName="cartPage__checkoutBtn"
            />
          </>
        ) : (
          <div className="cartPage__empty">
            <EmptyState
              icon={FaShoppingCart}
              title="Your cart is empty"
              description="Start adding products to your cart by browsing our collection."
              buttonText="Continue Shopping"
              onButtonClick={() => navigate("/")}
              iconSize={64}
            />
          </div>
        )}
      </main> */}
      {selectedItem && (
        <CartQtyUpdateModal
          visible={showQtyModal}
          onCancel={onCancelQty}
          onApply={handleUpdateQty}
          initialQty={selectedItem?.qty?.toString()}
        />
      )}

      <CommonFooter />
    </div>
  );
};

export default Cart;
